module.exports = __webpack_public_path__ + "static/16-e066eb5ee119f7725a4b5f3e9bd2c91a.png";